const TOKEN_KEY = "authToken";

export function setToken(token) {
	localStorage.setItem(TOKEN_KEY, token);
}

export function getToken() {
	return localStorage.getItem(TOKEN_KEY) || null;
}

export function removeToken() {
	localStorage.removeItem(TOKEN_KEY);
}

export { TOKEN_KEY };

// Optional helper used by some API modules
export function getAuthHeader() {
	const token = getToken();
	return token ? { Authorization: `Bearer ${token}` } : {};
}


